<template>
  <div class="banner-scroll" v-if="data.length" @touchmove.stop>
    <div class="banner-list">
      <div
        class="banner-item"
        :class="data.length == 1 ? 'banner-item-one' : ''"
        :style="{ backgroundColor: background }"
        v-for="(item, index) in data"
        :key="index"
        @click="bindClick(item)"
      >
        <img class="image" :src="item.img" alt="" />
        <div class="banner-item-right">
          <div class="title ellipsis">{{ item.title }}</div>
          <div class="desc ellipsis">{{ item.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    /* 资源位item背景色 */
    background: {
      type: String,
      default: '#F9F9F9'
    }
  },
  data() {
    return {}
  },
  methods: {
    bindClick(item) {
      if (this.$http._isApp()) {
        item.router && this.$betterwe.onAppPageRoute(item.router)
      } else {
        location.href = 'https://member3.gymcity.com.cn/#/app-download'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.banner-scroll {
  width: 100%;
  overflow-x: scroll;

  .banner-list {
    display: inline-flex;
    align-items: center;
    padding: 0px 16px;

    .banner-item {
      width: 230px;
      background: #ffffff;
      display: flex;
      align-items: center;
      border-radius: 8px;
      margin-right: 10px;
      padding: 10px;
      box-sizing: border-box;

      .image {
        width: 32px;
        height: 32px;
        border-radius: 4px;
        object-fit: cover;
        overflow: hidden;
        margin-right: 10px;
      }

      .banner-item-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .ellipsis {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .title {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 17px;
        }

        .desc {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #888888;
          line-height: 14px;
        }
      }
    }
    .banner-item-one {
      width: 343px;
    }
    .banner-item:last-child {
      margin-right: 0;
    }
  }
}
</style>
